export default "__VITE_ASSET__BFq2Dl5Q__"